export const SET_COLLECTIONS_BYID = 'folders/collections/SET_COLLECTIONS_BYID'
export const TOGGLE_COLLECTION = 'folders/collections/TOGGLE_COLLECTION'
export const OPEN_ONE_COLLECTION = 'folders/collections/OPEN_ONE_COLLECTION'
export const BUILD_FROM_WIDGETS = 'folders/BUILD_FROM_WIDGETS'
export const BUILD_INBOX_MENU_FROM_MAILBOXES =
  'folders/BUILD_INBOX_MENU_FROM_MAILBOXES'
